import React from 'react';

export const arrayToI18nList = (arr, conjunction = 'and') => {
  let list;
  if (!Array.isArray(arr) || (arr.length < 2)) {
    list = arr;
  } else if (arr.length === 2) {
    list = (<span>{arr[0]} {conjunction} {arr[1]}</span>);
  } else {
    // list = `${arr.slice(0, -1)}, ${conjunction} ${arr.slice(-1)}`;
    list = (
      <span>{
        arr.slice(0, -2).map((el, i) => {
          return <span key={i}>{el}, </span>
        })
      } {arr[arr.length - 2]} {conjunction} {arr.slice(-1)}</span>
    );
  }

  return list;
};

export const isoDateFormat = (datePublised) => {
  let date = datePublised.split("-"); 
  return (date[2] + "-" + date[1] + "-" + date[0]);
}

/* 
* Remove multiple spaces and special characters with single hypen(-) 
*/
export const toDashCase = (str) => {
  return str.replace(/[^A-Z0-9]+/ig, "-")
}

export const truncate = (text, number ) => {
  return (text.length > number) ? text.substr(0, number).concat('...') : text;
}

export const rotateArray = (array, steps) => {
  // check if there's even something to rotate
  if(array.length < 2) {
    return array.slice(0);
  }

  // get the number of actual rotations to perform
  let n = steps % array.length;

  // check if there's any need to rotate
  if(n === 0) {
    return array.slice(0); // return a copy
  }

  // slice and concat
  return array.slice(n).concat(array.slice(0, n));
}





// WEBPACK FOOTER //
// ./src/lib/textUtils.js